import React from 'react';
import { formatPriceLabel } from '../../utils/helpers';

const PriceRow = ({ title, price, isPackage, personalPrice, suvPrice, features }) => {
  // Handle different price formats (ranges, per-piece, "od" prices)
  const formatPrice = (price) => {
    return formatPriceLabel(price);
  };

  if (isPackage) {
    return (
      <div className="py-4 border-b border-white/10">
        <div className="flex justify-between items-center mb-2">
          <span className="text-white font-semibold">{title}</span>
          <div className="text-right">
            <div className="text-primary-400">
              <span className="text-sm">Auto osobowe: </span>
              <span className="font-semibold">{formatPrice(personalPrice)}</span>
            </div>
            <div className="text-primary-400">
              <span className="text-sm">SUV/Van: </span>
              <span className="font-semibold">{formatPrice(suvPrice)}</span>
            </div>
          </div>
        </div>
        {features && features.length > 0 && (
          <ul className="mt-2 text-sm text-gray-300 list-disc list-inside">
            {features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        )}
      </div>
    );
  }

  const displayPrice = formatPrice(price);

  return (
    <div className="flex justify-between items-center py-3 border-b border-white/10">
      <span className="text-white">{title}</span>
      <span className="text-primary-400 font-semibold">{displayPrice}</span>
    </div>
  );
};

const PriceTable = ({ services }) => {
  return (
    <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-6">
      <div className="space-y-1">
        {services.map((service, index) => (
          <PriceRow
            key={index}
            title={service.title}
            price={service.price}
            isPackage={service.category === 'Pakiety'}
            personalPrice={service.personalPrice}
            suvPrice={service.suvPrice}
            features={service.features}
          />
        ))}
      </div>
      {services.some(service => service.category === 'Pakiety') && (
        <div className="mt-4 text-sm text-gray-400 italic">
          * sierść psa, auta pobudowlane oraz robocze wycena indywidualna
        </div>
      )}
    </div>
  );
};

export default PriceTable;
